import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import classes from './Donut.module.scss';

const Donut = ({ data }) => {
  const { values, valueLabel } = data;

  const defoultValue = {
    size: 128,
    strokewidth: 7
  };

  const halfsize = defoultValue.size * 0.5;
  const radius = halfsize - defoultValue.strokewidth * 0.5;
  const circumference = 2 * Math.PI * radius;
  const strokeval1 = (values.essential * circumference) / values.valueMax;
  const strokeval2 = (values.standard * circumference) / values.valueMax;
  const strokeval3 = (values.premium * circumference) / values.valueMax;
  const dashval1 = strokeval1 + ' ' + circumference;
  const dashval2 = strokeval2 + strokeval1 + ' ' + circumference;
  const dashval3 = strokeval3 + strokeval2 + strokeval1 + ' ' + circumference;

  const trackstyle = { strokeWidth: defoultValue.strokewidth };
  const indicatorstyle1 = {
    strokeWidth: defoultValue.strokewidth,
    strokeDasharray: dashval1
  };
  const indicatorstyle2 = {
    strokeWidth: defoultValue.strokewidth,
    strokeDasharray: dashval2
  };
  const indicatorstyle3 = {
    strokeWidth: defoultValue.strokewidth,
    strokeDasharray: dashval3
  };
  const rotateval = 'rotate(-90 ' + halfsize + ',' + halfsize + ')';

  return (
    <div className={classes.chartContainer}>
      <svg
        width={defoultValue.size}
        height={defoultValue.size}
        className={classes.donutchart}
      >
        {values.valueMax ? (
          <>
            <circle
              r={radius}
              cx={halfsize}
              cy={halfsize}
              transform={rotateval}
              style={trackstyle}
              className={cn(classes.donutchart_indicator, classes.red)}
            />
            {values.premium && (
              <circle
                r={radius}
                cx={halfsize}
                cy={halfsize}
                transform={rotateval}
                style={indicatorstyle3}
                className={cn(classes.donutchart_indicator, classes.yellow)}
              />
            )}
            {values.standard && (
              <circle
                r={radius}
                cx={halfsize}
                cy={halfsize}
                transform={rotateval}
                style={indicatorstyle2}
                className={cn(classes.donutchart_indicator, classes.green)}
              />
            )}
            {values.essential && (
              <circle
                r={radius}
                cx={halfsize}
                cy={halfsize}
                transform={rotateval}
                style={indicatorstyle1}
                className={cn(classes.donutchart_indicator, classes.blue)}
              />
            )}
          </>
        ) : (
          <circle
            r={radius}
            cx={halfsize}
            cy={halfsize}
            transform={rotateval}
            style={trackstyle}
            className={cn(classes.donutchart_track, classes.grey)}
          />
        )}

        <text x={halfsize} y={halfsize} style={{ textAnchor: 'middle' }}>
          <tspan
            className={classes.donutchart_text__val}
            x={halfsize}
            y={halfsize}
          >
            {values.valueMax}
          </tspan>
          <tspan
            className={classes.donutchart_text__label}
            x={halfsize}
            y={halfsize + 16}
          >
            {valueLabel}
          </tspan>
        </text>
      </svg>
    </div>
  );
};

Donut.propTypes = {
  data: PropTypes.object
};

export default Donut;
